import request from "@/utils/request";
  
  // 下拉列表（下拉选择）
  export function loadSurveyProductSettingListApi(data) {
    return request({
      url: "web/surveyProductSetting/listSelectData",
      method: "post",
      data
    });
  }
  
  // 更新采集零售户单品采集品规设置
  export function updateCollectStoreInfoSingleProductApi(data) {
    return request({
      url: "web/surveyProductSetting/updateCollectStoreInfoSingleProduct",
      method: "post",
      data
    });
  }

  // 品规调查列表(主数据列表)
export function loadSurveyProductInfoListDataApi(data) {
  return request({
    url: "web/surveyProductInfo/listData",
    method: "post",
    data
  });
}
// 品规调查导出
export function loadSurveyProductInfoExportDataApi(data) {
  return request({
    url: "web/surveyProductInfo/exportData",
    method: "post",
    data
  });
}
// 保存调查
export function saveOrUpdateSurveyProductInfoApi(data) {
  return request({
    url: "web/surveyProductInfo/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看调查
export function initSurveyProductInfoApi(data) {
  return request({
    url: "web/surveyProductInfo/init",
    method: "post",
    data
  });
}

// 根据条件查询
export function findSurveyProductInfoByConditionApi(data) {
  return request({
    url: "web/surveyProductInfo/findListByCondition",
    method: "post",
    data
  });
}